import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";
import React from "react";
import { User } from "../shared/interfaces/User";

interface UserActionsTemplateProps {
  rowData: User;
  onUserDetailClick: (user: User) => void;
}

export function UserActionsTemplate(props: UserActionsTemplateProps) {
  return (
    <Button variant="contained" color="primary" onClick={() => props.onUserDetailClick(props.rowData)}>
      <VisibilityIcon />
    </Button>
  );
}
